var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advisory-step',{attrs:{"step":_vm.currentStep},on:{"next":_vm.next,"back":_vm.back,"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }